// 家庭管理模块配置
export const familyConfig = {
  // 模块基本信息
  name: '家庭管理',
  description: '和谐、温馨、成长',
  icon: 'HomeOutlined',
  bgColor: '#FFE4E1',
  iconColor: '#333333',
  
  // API 端点
  apiEndpoints: {
    // 家庭财务
    finance: '/family/finance',
    createFinance: '/family/finance',
    updateFinance: '/family/finance',
    deleteFinance: '/family/finance',
    
    // 家务分工
    chores: '/family/chores',
    createChore: '/family/chores',
    updateChore: '/family/chores',
    deleteChore: '/family/chores',
    
    // 家庭时间
    schedule: '/family/schedule',
    createSchedule: '/family/schedule',
    updateSchedule: '/family/schedule',
    deleteSchedule: '/family/schedule',
    
    // 家庭会议
    meetings: '/family/meetings',
    createMeeting: '/family/meetings',
    updateMeeting: '/family/meetings',
    deleteMeeting: '/family/meetings',
    
    // 子女成长
    children: '/family/children',
    createChild: '/family/children',
    updateChild: '/family/children',
    deleteChild: '/family/children',
    growth: '/family/growth',
    createGrowth: '/family/growth',
    addGrowth: '/family/growth',
    updateGrowth: '/family/growth',
    deleteGrowth: '/family/growth',
    
    // 健康管理
    health: '/family/health',
    createHealth: '/family/health',
    updateHealth: '/family/health',
    deleteHealth: '/family/health',
    
    // 沟通记录
    communication: '/family/communication',
    createCommunication: '/family/communication',
    updateCommunication: '/family/communication',
    deleteCommunication: '/family/communication',
    
    // 统计信息
    stats: '/family/stats'
  },
  
  // 财务类型
  financeTypes: [
    { key: 'budget', name: '月度预算', icon: '💰', color: '#52C41A' },
    { key: 'savings', name: '存款目标', icon: '🏦', color: '#1890FF' },
    { key: 'investment', name: '股票基金', icon: '📈', color: '#FAAD14' },
    { key: 'insurance', name: '保险', icon: '🛡️', color: '#722ED1' },
    { key: 'assets', name: '固定资产', icon: '🏠', color: '#13C2C2' },
    { key: 'expenses', name: '日常支出', icon: '💸', color: '#FF6B6B' }
  ],
  
  // 家务类型
  choreTypes: [
    { key: 'cleaning', name: '清洁卫生', icon: '🧹', color: '#52C41A' },
    { key: 'cooking', name: '烹饪做饭', icon: '👨‍🍳', color: '#FAAD14' },
    { key: 'laundry', name: '洗衣整理', icon: '👕', color: '#1890FF' },
    { key: 'shopping', name: '采购购物', icon: '🛒', color: '#722ED1' },
    { key: 'maintenance', name: '维修保养', icon: '🔧', color: '#13C2C2' },
    { key: 'education', name: '教育辅导', icon: '📚', color: '#FF6B6B' },
    { key: 'other', name: '其他', icon: '📝', color: '#D9D9D9' }
  ],
  
  // 活动类型
  activityTypes: [
    { key: 'weekend', name: '周末活动', icon: '🎉', color: '#52C41A' },
    { key: 'travel', name: '旅行记录', icon: '✈️', color: '#1890FF' },
    { key: 'party', name: '聚会庆祝', icon: '🎊', color: '#FAAD14' },
    { key: 'sports', name: '运动健身', icon: '🏃', color: '#722ED1' },
    { key: 'culture', name: '文化活动', icon: '🎭', color: '#13C2C2' },
    { key: 'education', name: '学习教育', icon: '📖', color: '#FF6B6B' }
  ],
  
  // 会议类型
  meetingTypes: [
    { key: 'regular', name: '定期会议', icon: '📅', color: '#52C41A' },
    { key: 'emergency', name: '紧急会议', icon: '🚨', color: '#FF6B6B' },
    { key: 'planning', name: '计划会议', icon: '📋', color: '#1890FF' },
    { key: 'review', name: '总结会议', icon: '📊', color: '#FAAD14' },
    { key: 'decision', name: '决策会议', icon: '✅', color: '#722ED1' }
  ],
  
  // 成长记录类型
  growthTypes: [
    { key: 'physical', name: '身体发育', icon: '📏', color: '#52C41A' },
    { key: 'academic', name: '学业状况', icon: '📚', color: '#1890FF' },
    { key: 'hobby', name: '兴趣爱好', icon: '🎨', color: '#FAAD14' },
    { key: 'social', name: '社交能力', icon: '👥', color: '#722ED1' },
    { key: 'skill', name: '技能发展', icon: '🎯', color: '#13C2C2' },
    { key: 'emotion', name: '情感发展', icon: '💝', color: '#FF6B6B' }
  ],
  
  // 健康管理类型
  healthTypes: [
    { key: 'diet', name: '饮食习惯', icon: '🍎', color: '#52C41A' },
    { key: 'exercise', name: '运动健身', icon: '🏃', color: '#1890FF' },
    { key: 'sleep', name: '睡眠质量', icon: '😴', color: '#FAAD14' },
    { key: 'mental', name: '心理健康', icon: '🧠', color: '#722ED1' },
    { key: 'balance', name: '生活平衡', icon: '⚖️', color: '#13C2C2' },
    { key: 'medical', name: '医疗保健', icon: '🏥', color: '#FF6B6B' }
  ],
  
  // 沟通类型
  communicationTypes: [
    { key: 'daily', name: '日常交流', icon: '💬', color: '#52C41A' },
    { key: 'serious', name: '重要谈话', icon: '🤝', color: '#1890FF' },
    { key: 'conflict', name: '冲突解决', icon: '⚡', color: '#FF6B6B' },
    { key: 'support', name: '情感支持', icon: '💝', color: '#FAAD14' },
    { key: 'planning', name: '计划讨论', icon: '📋', color: '#722ED1' },
    { key: 'feedback', name: '反馈建议', icon: '📝', color: '#13C2C2' }
  ],
  
  // 家庭管理TIPS
  familyManagementTips: {
    title: '家庭管理TIPS',
    tips: [
      {
        title: '建立良好的沟通机制',
        description: '定期召开家庭会议，倾听每个家庭成员的想法和需求',
        icon: '💬'
      },
      {
        title: '合理分工协作',
        description: '根据家庭成员的能力和兴趣，合理分配家务和职责',
        icon: '🤝'
      },
      {
        title: '制定家庭预算',
        description: '建立透明的财务管理制度，共同制定和遵守预算计划',
        icon: '💰'
      },
      {
        title: '关注子女成长',
        description: '记录孩子的成长轨迹，关注他们的身心健康和全面发展',
        icon: '👶'
      },
      {
        title: '保持健康生活方式',
        description: '培养良好的饮食、运动和睡眠习惯，维护全家人的健康',
        icon: '🏃'
      },
      {
        title: '创造美好回忆',
        description: '定期组织家庭活动，创造温馨和谐的家庭氛围',
        icon: '📸'
      }
    ]
  },
  
  // 家庭管理原则
  familyPrinciples: {
    title: '家庭管理五大原则',
    principles: [
      {
        title: '爱与尊重',
        description: '以爱为基础，相互尊重，建立和谐的家庭关系',
        icon: '💝'
      },
      {
        title: '沟通与理解',
        description: '保持开放和诚实的沟通，理解彼此的需求和感受',
        icon: '💬'
      },
      {
        title: '责任与担当',
        description: '每个成员都要承担相应的责任，共同维护家庭',
        icon: '🤝'
      },
      {
        title: '成长与学习',
        description: '鼓励家庭成员不断学习和成长，共同进步',
        icon: '📚'
      },
      {
        title: '平衡与和谐',
        description: '在工作和家庭之间找到平衡，创造和谐的生活',
        icon: '⚖️'
      }
    ]
  }
};
